import type { FC } from 'react';
import styled from 'styled-components';

import { useAppViewer } from './AppViewer.hooks';
import { Viewer } from './Viewer';

import cameraImage from './camera.svg';

const Container = styled.div<{ $height: string; $width: string }>`
  background-color: #e5e5f7;
  background-image:
    repeating-linear-gradient(
      45deg,
      #999999 25%,
      transparent 25%,
      transparent 75%,
      #999999 75%,
      #999999
    ),
    repeating-linear-gradient(45deg, #999999 25%, #e5e5f7 25%, #e5e5f7 75%, #999999 75%, #999999);
  background-position:
    0 0,
    20px 20px;
  background-size: 40px 40px;
  display: block;
  height: ${({ $height }) => $height};
  position: relative;
  width: ${({ $width }) => $width};
`;

const CaptureButton = styled.button`
  border-radius: 4px;
  left: 0;
  position: absolute;
  top: 0;
`;

const CaptureImage = styled.img`
  height: 39px;
  width: 32px;
`;

export const AppViewer: FC = () => {
  const {
    config,
    featureFlags,
    handleDownloadImage,
    handleUpdate,
    resolution,
    scene,
    viewerRef,
    visible,
  } = useAppViewer();

  return (
    <Container $height={`${resolution.y}px`} $width={`${resolution.x}px`}>
      {scene && (
        <>
          <Viewer
            backgroundAlpha={0}
            backgroundColor="#000000"
            config={config}
            featureFlags={featureFlags}
            id="canvas"
            onUpdate={handleUpdate}
            preserveDrawingBuffer={true}
            ref={viewerRef}
            scene={scene}
            showGarmentGeometry={true}
            visible={visible}
          />
          <CaptureButton onClick={handleDownloadImage}>
            <CaptureImage src={cameraImage} />
          </CaptureButton>
        </>
      )}
    </Container>
  );
};
